export const LogoMark = ({ size = 34, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    data-testid="logo-mark"
  >
    <defs>
      <linearGradient id="goldGrad" x1="0" y1="0" x2="48" y2="48">
        <stop offset="0%" stopColor="#BF953F" />
        <stop offset="35%" stopColor="#FCF6BA" />
        <stop offset="65%" stopColor="#D4AF37" />
        <stop offset="100%" stopColor="#AA771C" />
      </linearGradient>
    </defs>
    <path
      d="M10 10v23q0 8 8 8h12q8 0 8-8V10"
      stroke="url(#goldGrad)"
      strokeWidth="2.6"
      strokeLinecap="round"
    />
    <ellipse cx="24" cy="10" rx="14" ry="5.5" stroke="url(#goldGrad)" strokeWidth="2.6" />
    <path
      d="M10 16c0 3 6.3 5.5 14 5.5s14-2.5 14-5.5"
      stroke="url(#goldGrad)"
      strokeWidth="2.6"
    />
  </svg>
);

export const LogoFull = ({ compact = false }) => (
  <div className="flex items-center gap-3" data-testid="logo-full">
    <LogoMark size={compact ? 37 : 39} />
    <div className="leading-none">
      <span className={`font-extrabold tracking-tight text-[#F5F3EF] ${compact ? "text-[23px]" : "text-[17px]"}`} style={{ fontFamily: '"Plus Jakarta Sans", sans-serif' }}>
        TubeBoxes <span className="foil-text font-serif-display italic font-semibold">Direct</span>
      </span>
      <span className={`block mt-1.5 text-[#A1A8B3] ${compact ? "text-[12px]" : "text-[11px]"}`}>
        Custom Tube Boxes. Built for Brands.
      </span>
    </div>
  </div>
);
